module.exports = __webpack_public_path__ + "img/bg_pop_top.a71aa482.png";